module.exports = __webpack_public_path__ + "img/print-icon.80afe1d4.svg";